import { Node } from "@tiptap/core";

export const AI_HELPER_CHANGE_REQUEST_AUTHOR = "ai-helper";
export type ChangeRequestMode = "insert" | "replace" | "delete";
export type ChangeRequestPartKind = "before" | "after";

export const ChangeRequestPart = Node.create({
  name: "changeRequestPart",

  content: "block+",

  group: "block",

  defining: true,

  addAttributes() {
    return {
      kind: { default: "after" },
    };
  },

  parseHTML() {
    return [{ tag: "change-request-part" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["change-request-part", HTMLAttributes, 0];
  },
});

export const ChangeRequest = Node.create({
  name: "changeRequest",

  content: "changeRequestPart+",

  group: "block",

  defining: true,

  addAttributes() {
    return {
      changeRequestId: { default: null },
      author: { default: null },
      mode: { default: "insert" },
      pendingAt: { default: null, rendered: false },
    };
  },

  parseHTML() {
    return [{ tag: "change-request" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["change-request", HTMLAttributes, 0];
  },
});
